(function($) {

    $.fn.cookie = function(config) {

        var defaults = {
            close: '.js-cookie-close'
        };

        var options = $.extend(defaults, config);

        var $self = this;

        var setCookie = function(cname,cvalue,exdays,path) {
            var d = new Date();
            d.setTime(d.getTime()+(exdays*24*60*60*1000));
            var expires = "expires="+d.toGMTString();
            document.cookie = cname + "=" + cvalue + "; " + expires + ";" + "path=" + path;
        };

        var toggleCookie = function () {
            $self.hide();

            if (document.cookie.indexOf('accept-cookies') < 0) {
                $self.show();
            }
        };

        $self.on('click', options.close, function() {
            $self.slideUp(function() {
                $self.remove();
            });
            setCookie('accept-cookies',1,365,"/");
        });

        toggleCookie();

        return this;

    };

})(jQuery);
